import { Box, Stack } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useAtomValue } from "jotai";
import { TEAM_DETAILS_POPOVER_CHART_TEXTS } from "../../constants";
import { buildHypothesisStatChartByTeam } from "../../services/charts/buildHypothesisStatChartByTeam";
import { baseAtom } from "../../stores/jotai/base";

const TeamAnalytics = (props) => {
    const { chartData,statAtomState } = props;
    const base = useAtomValue(baseAtom);
    const theme = useTheme();
    const { team } = base;
    const teamName = team?.name;

    const getTeamContextualData = () => {
        let expectedData = {
            hypothesesOfTeam: undefined,
            periodsOfTeam: undefined,
            startDate: undefined,
            endDate: undefined,
        };

        try {
            expectedData.hypothesesOfTeam =
                statAtomState.data?.discoverySet[0].hypotheses || [];
            expectedData.periodsOfTeam =
                statAtomState.data?.discoverySet[0].cohort.periods || [];
            expectedData.startDate =
                statAtomState.data?.discoverySet[0].cohort.startDate;
            expectedData.endDate = statAtomState.data?.discoverySet[0].cohort.endDate;
        } catch (e) {}

        return expectedData;
    };

    const prepareTeamInterviewInsightsChartData = (originalData) => {
        const chart = originalData?.chart || [];
        const series = originalData?.plotOptions?.series || [];
        const title = originalData?.title || {};

        return {
            ...originalData,
            chart: {
                ...chart,
                type: "line",
            },
            plotOptions: {
                series: {
                    ...series,
                    marker: {
                        enabled: false,
                    },
                },
            },
            title: {
                ...title,
                text: TEAM_DETAILS_POPOVER_CHART_TEXTS.INTERVIEW_INSIGHT_CHART.TITLE,
            },
        };
    };

    const prepareTeamMemberInterviewInsightsChartData = (originalData) => {
        const title = originalData?.title || {};

        return {
            ...originalData,
            title: {
                ...title,
                text: TEAM_DETAILS_POPOVER_CHART_TEXTS.INTERVIEW_INSIGHT_CHART_BY_MEMBER
                    .TITLE,
            },
        };
    };

    const { hypothesesOfTeam, periodsOfTeam, startDate, endDate } =
        getTeamContextualData();

    const interviewsAndInsightsChartDataForTeam =
        prepareTeamInterviewInsightsChartData(
            chartData[`interviews_and_insights_by_week_${teamName}`]
        );
    const hypothesisStatsChartDataForTeam = buildHypothesisStatChartByTeam({
        hypotheses: hypothesesOfTeam,
        periods: periodsOfTeam,
        startDate,
        endDate,
    });
    const interviewsAndInsightsChartDataForTeamByMember =
        prepareTeamMemberInterviewInsightsChartData(
            chartData[`interviews_and_insights_by_member_${teamName}`]
        );

    return (
        <Stack
            className="TeamAnalytics-container"
            spacing={4}
            sx={{
                background: "white",
                padding: "0px !important",
                margin: "0px",
                "*": {
                    fontFamily: `${theme.custom.fontFamily} !important`,
                }
            }}
        >
            <Box>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={interviewsAndInsightsChartDataForTeam}
                />
            </Box>
            <Box>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={hypothesisStatsChartDataForTeam}
                />
            </Box>
            <Box>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={interviewsAndInsightsChartDataForTeamByMember}
                />
            </Box>
        </Stack>
    );
};

export default TeamAnalytics;
